module.exports = __webpack_public_path__ + "static/media/Avenir-Medium-Oblique.94eb3a09.otf";